import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/questionnaire-image-1.png")